import { render, staticRenderFns } from "./growTablev1.0.vue?vue&type=template&id=1ae72823&scoped=true"
import script from "./growTablev1.0.vue?vue&type=script&lang=js"
export * from "./growTablev1.0.vue?vue&type=script&lang=js"
import style0 from "./growTablev1.0.vue?vue&type=style&index=0&id=1ae72823&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae72823",
  null
  
)

export default component.exports